import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Traducciones en inglés
const resources = {
    en: {
        translation: {
            language: {
                spanish: "Español",
                english: "English"
            },
            navBar: {
                us: "ABOUT US",//                    us:"About Us",
                banks: "BANKS",//                    banks:"Banks",
                retail: "RETAIL",//                    retail:"Retail",
                atms: "ATMs",//                    atms:"ATMs",
                school: "SCHOOL",//                    school:"School",
                services: "SERVICES",//                    services:"Services",
                contact: "CONTACT"//                    contact:"contact"
            },
            banner: {
                transforming: "Transforming",
                selfService: "Self-Service",
                innovate: "with Innovative",
                technology: "Technology",
                bannerImage1: "Discover our extensive technology portfolio",
                bannerImage2: "We support innovation in your organization",
                bannerImage3: "We optimize cash management processes",
                tailor: "Tailor-made solutions",
                madeSolutions: "",
                atmDescription: "By training your staff, we help optimize your processes and reduce operating costs.",
                phoneNumber: "Phone number"
            },
            aboutUs: {
                innovation: "Innovation,",
                security: "Security,",
                development: "Development",
                text1: "With over 22 years of experience, we provide solutions that enhance the operational efficiency of the financial sector. We support technological innovation by offering a full suite of services, system solutions, and hardware required for comprehensive self-service channels.",
                text2: "Trusted by Leading Organizations Around the World",
                title1: "Global",
                title2: "Presence",
                text3: "As a globally connected commerce company, we have the reach, scale, and expertise to deliver tailored solutions.",
                subtitle1: "Explore our global presence using our interactive map",
                innovatedSolutions: "Innovative self-service",
                selfServiceInstalled: "solutions installed",
                operating: "Operating",
                atms: "ATMs",
                associated: "Trusted industry",
                reliable: "partnerships",
                ourLocations: "Our locations",
                findUs: "Find our headquarters and service centers near you.",
                textbetween: "We operate across the United States, Colombia, Ecuador, and Guatemala, with logistics centers strategically positioned to support regional operations. In today’s interconnected world, we are helping shape the future of transactions while expanding our global footprint.",
                logisticCenter: "Logistic Center",
                repairCenter: "Repair Center",
                netScholl: "ATMnet School"

            },
            banksSection: {
                banksTitle: "Banks",
                subtitle1: "Accelerate the transformation of your banking services",
                text1: "Secure and advanced ATMs that reflect our constant pursuit of innovation in financial services",
                subtitle2: "Explore Our Banking Solutions",
                text2: "We offer innovative, bank-specific solutions that enhance self-service capabilities and elevate the customer experience.",
                subtitle3: "Explore Our Rental Equipment Portfolio",
                text3: "We tailor our solutions to each project’s requirements and our clients’ business models. We offer ATM rental services for organizations looking to optimize their technology investment.",
                subtitle4: "Focused on Eco-Friendly Self-Service",
                text4: "ATM recovery not only saves money but supports sustainability. We offer a wide range of services, including refurbishment, enabling financial institutions to modernize operations and meet consumer demands for innovation, security, and flexibility—while reducing costs or driving growth",
                titleTrusted: "Trusted by the world's leading financial institutions",
                solutions: "Solutions – Step by Step",
                services: "Services",
                consulting: "Consulting",
                fmlslm: "Nationwide FLM and SLM maintenance",
                training: "Training",
                construction: "ATM site construction & installation",
                warehouse: "ATM storage & mobilization",
                products: "Products",
                sellsAtms: "ATM Sales:",
                refurbished: "New / Refurbished.",
                rentals: "ATM Rentals:",
                rebuilt: "New / Rebuilt.",
                parts: "Parts and consumibles.",
                national: "nationwide.",
                installation: "equipament installation.",
                atmSites: "Construction and installation of ATM sites",
                btnContactUs: "Contact us"

            },
            retailSection: {
                title: "Retail",
                transforming: "Next-Generation Solutions",
                marketRetail: "for the retail market",
                tecnology: "Leverage cutting-edge technology",
                convert: "to gain a strategic edge.",
                services: "Services for banks",
                learn: "Learn more",
                inprove: "Enhancing Security with Interactive Cash Control Units",
                ourExperience: "Our deep industry experience enables us to design proprietary solutions tailored to your needs.",
                interactive: "• Interactive units for cash control \n • Online reporting systems \n • Development and implementation of transactional security platforms",
                development: "",
                portfolio: "Portfolio",
                solutions: "Solutions",
                solutionsTitle1: "Development of service strategies. VOI (Vendor Owned Inventory in Customer’s Network)",
                solutionsTitle2: "Implementation of POS systems",
                servicios: "Services",
                consulting: "Consulting",
                training: "Training",
                construction: "ATM construction and equipment installation",
                mantainance: "FLM and SLM maintenance",
                products: "Products",
                atmsSales: "ATMs for sale and rent",
                atmsRent: "Parts and Consumibles",
                parts: "Parts and consumibles",
                atmsServices: "ATMs as a service"

            },
            atmsSection: {
                title: "ATMs",
                discover: "Discover ATM Solutions with ATMNet",
                text1: "Manage costs, complexity, and risk with our comprehensive ATM services—letting you focus on growing your institution and delivering excellent customer service",
                textIndustrial: "We are authorized Cashway distributors, offering high-performance dispensers and recyclers.",
                rebuilt: "Rebuilt Solutions",
                textRebuilt: "ATM Net Systems promotes sustainability by offering rebuilt ATMs and reconstruction services for existing fleets. We work with major brands including Diebold-Nixdorf, NCR, and Hyosung."
            },
            faq: {
                title: "Frequently Asked Questions (FAQ)",
                questions: [
                    // ---------- Category: Common Issues ----------
                    {
                        q: "What technical issues do you solve for ATMs and how?",
                        a: `- Jammed or damaged bill dispensers.
- Recycling modules that don’t read correctly.
- EPPs (Encrypting PIN Pads) blocked or with errors.
- Card readers that fail.
- Outdated firmware.

ATMNet solution: quick module repair, spare parts in stock, remote support.`,
                        category: "common"
                    },
                    {
                        q: "What problems can high ATM downtime cause?",
                        a: `- ATMs out of service for hours or days.
- Transaction losses and dissatisfied clients.
- Reputational risk for banks or retail.

ATMNet solution: preventive maintenance, clear SLA service contracts, Vendor Owned Inventory (VOI).`,
                        category: "common"
                    },
                    {
                        q: "Why are maintenance and spare parts costs so high?",
                        a: `- Dependence on manufacturers with high prices.
- Delays in importing parts.
- Unexpected expenses due to recurring failures.

ATMNet solution: local inventories in Bogotá, Guayaquil, and Guatemala, competitive prices, refurbished spare parts with warranty.`,
                        category: "common"
                    },
                    {
                        q: "What security problems can an ATM have?",
                        a: `- Compromised keyboards/EPPs.
- Fraud risk due to manipulated modules.
- Lack of secure update protocols.

ATMNet solution: supply of EPPs, security protocols, technician training in best practices.`,
                        category: "common"
                    },
                    {
                        q: "What is the problem with lack of specialized technical staff?",
                        a: `- Banks and CITs do not always have trained staff.
- Staff turnover causes knowledge loss.

ATMNet solution: ATMNet School, hands-on training and certification for internal and third-party technicians.`,
                        category: "common"
                    },
                    {
                        q: "What common problems are related to low cash management efficiency?",
                        a: `- ATMs that don’t recycle bills efficiently.
- Errors in cash reconciliation.
- High logistics costs.

ATMNet solution: optimization of recycling modules, cash management consulting, self-service solutions integration.`,
                        category: "common"
                    },
                    {
                        q: "How many ATMs does ATM Net currently maintain?",
                        a: `We service over 3,000 ATMs across the region, working with banks, ATM networks, and cash-in-transit companies.`,
                        category: "common"
                    },
                    {
                        q: "How many years of experience do you have with NCR and Diebold Nixdorf?",
                        a: `We have over 23 years of experience working with NCR and Diebold Nixdorf, as well as other leading manufacturers in the market.`,
                        category: "common"
                    },
                    {
                        q: "What technical failures do you repair in ATMs?",
                        a: `We repair dispensers, recyclers, card readers, and EPPs, among others.
Our technicians diagnose, replace modules, and ensure full functionality before returning the unit.`,
                        category: "common"
                    },
                    {
                        q: "What problems result from high ATM downtime?",
                        a: `Lack of maintenance leads to:
- Equipment being out of service for hours or days.
- Lost transactions and dissatisfied customers.
- Reputational risks and operational overload.

Solution: preventive maintenance, SLA contracts, and the VOI model for immediate spare-part availability.`,
                        category: "common"
                    },
                    {
                        q: "Why do maintenance and spare-part costs increase?",
                        a: `- Dependence on manufacturers and import delays.
- Recurring failures and unexpected expenses.

Solution: local inventories, refurbished parts with warranty, and competitive pricing.`,
                        category: "common"
                    },
                    {
                        q: "What security risks can an ATM present?",
                        a: `- Compromised EPP (Encrypted Pin Pad) keypads.
- Tampered modules.
- Lack of secure software updates.

Solution: certified EPP supply, strict security protocols, and technical training.`,
                        category: "common"
                    },
                    {
                        q: "What is the impact of not having specialized technical staff?",
                        a: `- High turnover and loss of operational knowledge.

Solution: continuous education through ATM Net School with hands-on certification and multi-brand training.`,
                        category: "common"
                    },
                    {
                        q: "What are the most common issues in cash management?",
                        a: `- ATMs that fail to recycle bills efficiently.
- Reconciliation errors.
- High logistics costs for cash handling.

Solution: optimization of recyclers and consulting on cash-management efficiency.`,
                        category: "common"
                    },

                    // ---------- Category: Spare Parts ----------
                    {
                        q: "Are the parts you sell original or refurbished?",
                        a: `We offer original, generic, and refurbished parts—new or used—depending on the client’s needs and brand availability.
All parts go through a rigorous technical verification and quality-control process to ensure reliable field performance.`,
                        category: "spare"
                    },
                    {
                        q: "What warranty do the parts include?",
                        a: `New parts come with the manufacturer’s warranty.
Refurbished parts are covered for up to 30 days, backed by our certified laboratories.`,
                        category: "spare"
                    },
                    {
                        q: "How do you guarantee the security of the equipment during repairs?",
                        a: `All equipment is serviced in secure, audited laboratories that follow strict traceability, access control, and photographic record protocols.`,
                        category: "spare"
                    },

                    // ---------- Category: SLA ----------
                    {
                        q: "Can you ship critical spare parts in less than 24 hours?",
                        a: `Yes. When stock is available, we can ship critical parts within 24 hours, thanks to our logistics hubs in Bogotá, Guayaquil, and Guatemala City.`,
                        category: "sla"
                    },
                    {
                        q: "What does a preventive and corrective maintenance contract include?",
                        a: `Our contracts combine:
- Preventive maintenance, to prevent failures and extend the equipment’s life cycle.
- Corrective maintenance, to fix breakdowns and restore operations quickly.
- Service Level Agreements (SLAs) that define coverage, response times, and periodic performance reports.`,
                        category: "sla"
                    },
                    {
                        q: "Do you handle repairs onsite or only in the lab?",
                        a: `We offer both options. Our technical team performs repairs either onsite or in our labs, depending on the type of damage and the affected module.`,
                        category: "sla"
                    },
                    {
                        q: "How long does it take to repair a module?",
                        a: `It depends on the module type and parts availability, but the average repair time ranges from 1 to 4 hours.`,
                        category: "sla"
                    },
                    {
                        q: "Do you offer nationwide coverage?",
                        a: `Yes. We provide service in major cities and nearby areas, and we also partner with local providers to cover additional regions.`,
                        category: "sla"
                    },
                    {
                        q: "Do you offer 24/7 service?",
                        a: `We operate under customized SLA agreements, which can include 24/7 support depending on the contract type and operational criticality.`,
                        category: "sla"
                    },
                    {
                        q: "What is the VOI (Vendor-Owned Inventory) model?",
                        a: `It’s a model in which ATM Net retains ownership of the inventory, provided to the client under a monthly fee per ATM.
This fee covers the repair of contracted modules, optimizing costs, response times, and equipment uptime.`,
                        category: "sla"
                    },
                    {
                        q: "Do you offer volume discounts or annual contracts?",
                        a: `Yes. The more ATMs and longer the contract duration, the better the rate. Pricing is adjusted according to volume and coverage.`,
                        category: "sla"
                    },
                    {
                        q: "Can I purchase only parts, or do you also offer full service?",
                        a: `Both. You can purchase individual parts or opt for a comprehensive service that includes maintenance, support, and module replacement.`,
                        category: "sla"
                    },
                    {
                        q: "Do you offer FOB pricing or direct deliveries across Latin America?",
                        a: `Yes. We provide FOB/EXW pricing from the U.S. or Colombia and direct deliveries in Colombia, Ecuador, and Guatemala, depending on client preference.`,
                        category: "sla"
                    },
                    {
                        q: "What happens if the part I need is out of stock?",
                        a: `We check availability across our three regional hubs (Bogotá, Guayaquil, and Guatemala).
If unavailable, we import it directly from the manufacturer. The VOI model minimizes the risk of stock shortages.`,
                        category: "sla"
                    },

                    // ---------- Category: School ----------
                    {
                        q: "Can you train my technical team?",
                        a: `Yes. Through ATM Net School, we train internal or external technicians with hands-on programs focused on diagnostics, repair, and multi-brand maintenance.`,
                        category: "school"
                    },
                    {
                        q: "Are the courses in-person or virtual?",
                        a: `Most courses are in-person due to their practical nature.
However, we also offer hybrid formats and on-site training at the client’s facilities when needed.`,
                        category: "school"
                    },
                    {
                        q: "Do you issue certifications?",
                        a: `Yes. All our programs issue official ATM Net School certificates, recognized throughout the industry.`,
                        category: "school"
                    },
                    {
                        q: "Which ATM brands do you train on?",
                        a: `We provide training on major manufacturers, including NCR, Diebold Nixdorf, Hyosung, and Cashway—covering all models and generations.`,
                        category: "school"
                    },
                    {
                        q: "How long does each training program last?",
                        a: `Each training module lasts an average of 40 hours.
Prices vary depending on course complexity, ranging from USD 15,000 to USD 25,000.`,
                        category: "school"
                    }
                ]
            },


            titleHome: "Transforming self-service with innovative technology",
            description: "This is a sample application with multi-language support.",
            email_atm: "info@atmnetss.com",
            address_atm: "1555 Oakbrook Drive, Suite 105",
            zipcode_atm: "Norcross, Georgia 30093",
            phone: "Phone",
            general_information: "General Information",
            address: "Address",
            home_title_school: "ATMSchool",
            home_contact_text: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper",
            home_contact_text1: "Inquiries and Support For any questions or support requests, please fill out the form below.",
            home_contact_text2: "Prefer to speak with us directly? \n Give us a call:",
            school_titel1: "Promoting education in technique and technology through the experience at AtmSchool Net",
            school_text1: "At Atm Net Systems and Solutions, we understand the importance of education in the field of financial technology. We are committed to contributing to this field by integrating technique, technology, knowledge and product development to create secure and advanced ATMs. Our interactive units for money control and security, together with our online reporting systems, provide a comprehensive solution for financial institutions. Join us in shaping the future of fintech.",
            us: "Us",
            contact: "Contact",
            banks: "Banks",
            atms: "ATMs",
            services: "Services",
            retail: "Retail",
            footer: {
                cookies_settings: "Cookies Settings",
                terms_of_service: "Terms of Service",
                privacy_policy: "Privacy Policy",
                rights_reserved: "© 2025 Relume. All Rights Reserved"
            },
            school: {
                text_prueba: "Stay up to date with our latest product launches",
                title: "ATM net School",
                text1: "In our hands-on lab sessions, we improve service processes by developing efficient diagnostic methods and reconstruction practices.",
                text2: "At ATM Net Systems and Solutions, we believe in the power of education in financial technology. We integrate technical skills, innovation, and product development to build secure, advanced ATMs. Our interactive cash control systems and real-time reporting tools deliver comprehensive support for institutions. Join us in shaping the future of this industry.",
                text3: "",
                subtitle: "Promoting Technical Education for Smarter Financial Services",
                subtitle2: "to acquire analytical thinking in optimizing diagnosis and finding efficient solutions.",
                subtitle3: "Empowering Your Technicians",
                subtitle4: "Interested in Training Your Team?",
                text4: "Contact us for more details",
                title1: "Empowering Education through ATMs and Financial Technology",
                parrafo1: "In our laboratory sessions we transform processes to optimize resources and improve service. Search for solutions to errors with efficient processes, thanks to our long experience in the field and equipment reconstruction.",
                title2: 'Courses, Seminars & Workshops',
                title3: "Are you interested in training your teams?",
                parrafo3: "Contact us for more information.",
                numero: "Phone Number*",
                nombre: "Name(s)*",
                apellido: "Last name*",
                email: "Email*",
                select_field: "Choose a Topic",
                submit: "Submit",
                category: "category",
                titleImg1: "Service",
                titleImg2: "Laboratory",
                titleImg3: "Monitoring",
                titleImg4: "ATM Reconciliation & Shortage Analysis",
                titleImg5: "Frontline Technician Training",
                titleImg6: "ATM Protocols (NDC, Diebold 912)",
                textImg1: "Preventive and corrective ATM maintenance",
                textImg2: "Systems development for improving operational efficiency",
                textImg3: "Best practices in ATM monitoring and network management",
                textImg4: "",
                textImg5: "",
                textImg6: "",

            },
            atm: {
                title: "Discover ATM Solutions",
                parrafo1: "Control costs, complexity, and risk with our comprehensive ATM solution, a service that manages everything needed to operate the ATM channel. This allows you to focus on growing your financial institution and providing exceptional customer experiences."
            },
            contacto: {
                title: "Contact us!",
                text1: "Have questions or need support? Get in touch with us.",
                email: "Email",
                textEmail: "For any queries or support requests, please contact us. \n asaavedra@atmnetss.com",
                phone: "Phone",
                textPhone: "If you prefer to speak to us directly, please give us a call. \n  +1 770-449-6545",
                subtitle2: "Our locations",
                text2: "Find our headquarters and service centers near you",
                titleImg1: "Headquares: Atlanta, USA",
                textImg1: "North America",
                titleImg2: "Bogotá Colombia - Guayaquil Ecuador",
                textImg2: "Latin America",
                titleImg3: "Ciudad de Guatemala, Guatemala",
                textImg3: "Central America",
            },
            servicios: {
                title: "Our Services",
                subtitle1: "We advise",
                text1: "At ATM Net Systems and Solutions, we integrate technology, expertise, and product development to deliver secure and cutting-edge ATM solutions. Our extensive experience in self-service technologies allows us to support all leading ATM brands and help companies transform their operations.",
                textImg1: "Companies building low-cost or private ATM networks",
                textImg2: "Organizations seeking service upgrades",
                textImg3: "Cash-in-transit companies expanding their ATM operations",
                services: "Specialized Services",
                subtitle2: "Transnational Security Systems",
                text2: "Custom-built security solutions for logistics, using our technical and strategic expertise to protect assets in transit or storage.",
                subtitle3: "Secure Logistics Solutions",
                text3: "Comprehensive services covering transportation, storage, and distribution—designed to meet global logistics demands.",
                subtitle4: "Risk Mitigation",
                text4: "We assess security protocols and design custom strategies to safeguard assets across your logistics and service operations.",
                transforming: "Transforming Business Models Through Innovation",
                textTransform: "Contact us today for more information or to schedule a consulting session.",
                contactus: "Contact Us",
                solutions: "Solutions",
                item1: "ATM network integration",
                item2: "Vendor-Owned Inventory (VOI) strategies",
                item3: "POS, Banking & Retail system implementation",
                item4: "New and refurbished ATMs.",
                item5: "Parts & consumibles.",
                item6: "Consulting.",
                item7: "Training.",
                item8: "Nationwide ATM installation",
                item9: "Nationwide FLM & SLM maintenance",
                item10: "Specialized banking logistics",
                item11: "Security systems: transactional recording, access control",
                item12: "Forensic Analysis.",

            },
            seo: {
                home: {
                    title: "ATM Net Systems — Self-Service & ATM Technology",
                    description:
                        "We design, deploy and maintain self-service and ATM solutions for banks and retail. Consulting, logistics, training and nationwide maintenance across the US & LATAM.",
                    pathByLang: { en: "/", es: "/" },
                    keywords:
                        "ATM solutions, ATMNet, self-service technology, ATM consulting, ATM maintenance, ATM spare parts, ATM training, ATM repair US, ATM services LATAM"
                },
                about: {
                    title: "About ATM Net Systems — 22+ Years in Self-Service",
                    description:
                        "Global presence with hubs in the US and LATAM. Over 22 years improving financial operations with secure self-service, hardware, software and expert services.",
                    pathByLang: { en: "/en/about-us", es: "/nosotros" },
                    keywords:
                        "ATMNet company, ATMNet about us, ATM technology provider, ATM logistics, ATM repair LATAM, ATM experience 22 years, ATMNet solutions"
                },
                banks: {
                    title: "Banking Solutions — ATMs, Logistics & Security",
                    description:
                        "End-to-end ATM programs for banks: new/refurbished units, FLM/SLM maintenance, site build & install, logistics, parts, consulting and training.",
                    pathByLang: { en: "/en/banks", es: "/bancos" },
                    keywords:
                        "ATM bank solutions, ATM consulting, ATM contracts, ATM maintenance service, NCR ATM maintenance contract, ATM parts supplier, ATM technician certification NCR Diebold, ATM training Latin America"
                },
                retail: {
                    title: "Retail Solutions — Cash Control & POS Integration",
                    description:
                        "Proprietary retail technology: interactive cash control units, online reporting and transactional security platforms to cut losses and boost efficiency.",
                    pathByLang: { en: "/en/retail", es: "/retail" },
                    keywords:
                        "retail ATM solutions, cash management retail, POS integration ATM, ATM cash control units, ATM retail services LATAM"
                },
                atms: {
                    title: "ATM Solutions — New, Refurbished & Rebuilt",
                    description:
                        "Optimize cost and uptime with full-cycle ATM services: sales & rentals, rebuilds, nationwide maintenance, installation and inventory management.",
                    pathByLang: { en: "/en/atms", es: "/cajerosautomaticos" },
                    keywords:
                        "ATM spare parts supplier, Diebold ATM parts wholesale, NCR ATM dispenser module parts, ATM repair service Latin America, Diebold ATM service provider, ATM technical support, ATM fraud prevention services, ATM security solutions provider, Spare Parts ATM"
                },
                school: {
                    title: "ATMnet School — Training for Technicians & Operations",
                    description:
                        "Hands-on courses and workshops: preventive/corrective maintenance, protocols, monitoring best practices and lab methods to accelerate service quality.",
                    pathByLang: { en: "/en/school", es: "/school" },
                    keywords:
                        "ATMNet School, ATM technician training, ATM courses Latin America, ATM certification NCR Diebold, ATM technical knowledge, ATM lab training"
                },
                services: {
                    title: "Services — Consulting, Integration & Maintenance",
                    description:
                        "Specialized services for banking and retail: VOI strategies, ATM network integration, POS/Banking systems, secure logistics and risk mitigation.",
                    pathByLang: { en: "/en/services", es: "/servicios" },
                    keywords:
                        "ATM consulting services, ATM VOI strategies, ATM integration, POS system ATM, ATM nationwide maintenance, ATM security services, ATM forensic analysis"
                },
                contact: {
                    title: "Contact ATM Net Systems — US & LATAM Offices",
                    description:
                        "Get in touch for sales, support or training. Headquarters in Atlanta with regional presence in Colombia, Ecuador and Guatemala.",
                    pathByLang: { en: "/en/contact", es: "/contactenos" },
                    keywords:
                        "ATMNet contact, ATM services USA, ATM support LATAM, ATMNet Colombia, ATMNet Ecuador, ATMNet Guatemala offices"
                }
            }

        }

    },
    es: {
        translation: {
            language: {
                spanish: "Español",
                english: "English"
            },
            navBar: {
                us: "NOSOTROS",
                banks: "BANCOS",
                retail: "RETAIL",
                atms: "CAJEROS AUTOMATICOS",
                school: "SCHOOL",
                services: "SERVICIOS",
                contact: "CONTACTO"
            },
            banner: {
                transforming: "Transformando",
                selfService: "el autoservicio",
                innovate: "con innovadora",
                technology: "tecnología",
                bannerImage1: "Conozca nuestro amplio portafolio en tecnología",
                bannerImage2: "Optimizamos procesos de manejo del efectivo",
                bannerImage3: "Optimizamos procesos de manejo del efectivo",
                tailor: "Soluciones",
                madeSolutions: "a la medida",
                atmDescription: "Capacitando a su personal le ayudamos a optimizar sus procesos y a la reducción de costos operativos.",
                phoneNumber: "Teléfono"

            },
            aboutUs: {
                innovation: "Innovación,",
                security: "Seguridad,",
                development: "Desarrollo",
                text1: "22 años brindando soluciones para mejorar los procesos operativos del sector financiero. Con nuestra experiencia, acompañamos el mejoramiento en los procesos en innovación tecnológica, ofreciendo todos los servicios, soluciones de sistemas y hardware necesario para canales de autoservicio integral.",
                text2: "Con la confianza de las organizaciones líderes del mundo para su éxito",
                title1: "Presencia",
                title2: "Global",
                text3: "Como empresa mundial de comercio conectado a nivel global, nuestra organización tiene el alcance, el tamaño y el conocimiento necesarios para brindar soluciones adecuadas.",
                subtitle1: "Descubra nuestra presencia y alcance global con nuestro  mapa interactivo",
                innovatedSolutions: "Soluciones innovadoras de",
                selfServiceInstalled: "autoservicio instaladas",
                operating: "Cajeros automáticos en",
                atms: "servicio",
                associated: "Asociaciones industriales",
                reliable: "confiables",
                ourLocations: "Nuestras sedes",
                findUs: "Encuentre nuestras oficinas centrales y centros de servicio cerca de usted.",
                textbetween: " Somos una corporación global con una fuerte presencia local. En el mundo actual constantemente conectado, estamos influyendo en el futuro de las transacciones. Si bien nuestras soluciones se basan en ideales universales, se hacen realidad a través de distintas asociaciones regionales con nuestros clientes.",
                logisticCenter: "Centro Logístico",
                repairCenter: "Centro de Reparación",
                netScholl: "Escuela ATMnet"

            },
            banksSection: {
                banksTitle: "Bancos",
                subtitle1: "Acelere la transformación de sus servicios bancarios",
                text1: "Cajeros automáticos seguros y avanzados que reflejan nuestra constante búsqueda de innovación en servicios financieros.",
                subtitle2: "Explore nuestras soluciones para bancos",
                text2: "Ofrecemos una gama de soluciones innovadoras diseñadas específicamente para bancos, ayudándoles a mejorar sus capacidades de autoservicio y mejorar la experiencia del cliente.",
                subtitle3: "Explore nuestro portafolio de alquiler de equipos",
                text3: "Adaptamos nuestras soluciones a las necesidades de cada proyecto y el modelo de negocio de nuestros clientes. Prestamos el servicio de alquiler de equipos para compañías que deseen optimizar su tecnología.",
                subtitle4: "Enfocados en un autoservicio amigable con el medio ambiente",
                text4: "La recuperación de maquinas no solo permite ahorrar dinero sino además ayuda al medio ambiente. Ofrecemos una amplia gama de servicios, incluida la renovación. Con tecnología moderna, las instituciones financieras pueden modernizar sus operaciones para satisfacer las necesidades de innovación, seguridad y flexibilidad de los consumidores, ya sea aumentando el crecimiento o reduciendo costos.",
                titleTrusted: "Con la confianza de las principales instituciones financieras del mundo",
                solutions: "Soluciones",
                services: "Servicios",
                consulting: "Consultoría",
                fmlslm: "Mantenimiento FLM y SLM",
                training: "Entrenamiento",
                construction: "Construcción de sites para cajeros automáticos e instalación de equipos.",
                warehouse: "Wharehouse, movilización de cajeros",
                products: "Productos",
                sellsAtms: "Venta de Cajeros automáticos:",
                refurbished: "Nuevos / Remosados.",
                rentals: "Alquiler de Cajeros automáticos:",
                rebuilt: "Nuevos / Reconstruidos.",
                parts: "Partes y Consumibles",
                national: "a nivel nacional",
                installation: "automáticos e instalación de equipos.",
                atmSites: "Construcción de sites para cajeros",
                btnContactUs: "Contáctanos"
            },
            retailSection: {
                title: "Retail",
                transforming: "Transformando soluciones",
                marketRetail: "para el mercado de retail",
                tecnology: "Con la tecnología de punta que ofrecemos podemos",
                convert: "convertirnos en su aliado estratégico.",
                services: "Servicios para bancos",
                learn: "Conocer más",
                inprove: "Mejora de la seguridad con unidades interactivas de control de dinero",
                ourExperience: "Nuestra experiencia y proximidad tanto a los bancos, compañías de mantenimiento y compañías de servicio nos han permitido identificar las necesidades de los mismos para generar soluciones tecnológicas, propietarias, que se adaptan a los requerimientos de nuestros clientes.",
                interactive: "Unidades interactivas para el control y la seguridad del dinero, Sistemas de reporte en linea.",
                development: "Desarrollo e implementación de sistemas de seguridad transaccional.",
                portfolio: "Portafolio",
                solutions: "Soluciones",
                solutionsTitle1: "Desarrollo de estrategias de servicio. VOI (Vendor OwnedInventory in Customer’s Network)",
                solutionsTitle2: "Implementación de sistemas POS",
                servicios: "Servicios",
                consulting: "Consultoría",
                training: "Entrenamiento",
                construction: "Construcción de sites para cajeros automáticos e instalación de equipos",
                mantainance: "Mantenimiento FLM y SLM",
                products: "Productos",
                atmsSales: "Venta de Cajeros automáticos",
                atmsRent: "Alquiler de Cajeros automáticos",
                parts: "Partes y Consumibles",
                atmsServices: "Cajeros Automáticos como servicio"
            },
            atmsSection: {
                title: "Cajeros Automáticos",
                discover: "Descubra las soluciones para cajeros automáticos",
                text1: "Controle los costos, la complejidad y el riesgo con nuestra solución integral de cajeros automáticos, un servicio que maneja todo lo necesario para ejecutar el canal de cajeros automáticos, para que pueda concentrarse en hacer crecer su institución financiera y brindar experiencias excepcionales a los clientes.",
                textIndustrial: "Authorized Cashway distributors, with a wide range of recyclers and dispensers, hook added value.",
                rebuilt: "Reconstruidos",
                textRebuilt: "ATM NET Systems promueve las prácticas amigables con la medio ambiente, ofrecemos cajeros reconstruidos y prestando el servicie reconstrucción de cajeros de la flota instalada de las entidades financieras. Trabajamos Diebold-Nixdorf, NCR, Hyosong entre otras.",
            },
            faq: {
                title: "Preguntas Frecuentes (FAQ)",
                questions: [
                    // ---------- Categoría: Problemas ----------
                    {
                        q: "¿Qué fallas técnicas solucionan para cajeros automáticos y cómo lo hacen?",
                        a: `- Dispensadores de billetes atascados o dañados.
- Módulos recicladores que no leen correctamente.
- EPPs (Encrypting PIN Pads) bloqueados o con error.
- Lectores de tarjetas que fallan.
- Firmware desactualizado.

Solución ATMNet: reparación rápida de módulos, repuestos en stock, soporte remoto.`,
                        category: "common"
                    },
                    {
                        q: "¿Qué problemas puede causar la alta indisponibilidad del parque de cajeros?",
                        a: `- Cajeros fuera de servicio por horas o días.
- Pérdida de transacciones y clientes insatisfechos.
- Riesgo reputacional para el banco o retail.

Solución ATMNet: mantenimiento preventivo, contratos de servicio con SLA claros, VOI (Vendor Owned Inventory).`,
                        category: "common"
                    },
                    {
                        q: "¿Por qué hay costos elevados de mantenimiento y repuestos?",
                        a: `- Dependencia de fabricantes con precios altos.
- Demoras en importación de piezas.
- Gastos imprevistos por fallas recurrentes.

Solución ATMNet: inventarios locales en Bogotá, Guayaquil y Guatemala, precios competitivos, repuestos reacondicionados con garantía.`,
                        category: "common"
                    },
                    {
                        q: "¿Qué problemas de seguridad puede tener un cajero?",
                        a: `- Teclados/EPPs comprometidos.
- Riesgo de fraude por módulos manipulados.
- Falta de protocolos de actualización segura.

Solución ATMNet: provisión de EPPs, protocolos de seguridad, capacitación de técnicos en mejores prácticas.`,
                        category: "common"
                    },
                    {
                        q: "¿Cuál es el problema de la falta de personal técnico especializado?",
                        a: `- Alta rotación y pérdida de conocimiento operativo.
Solución: formación continua a través de ATM Net School, con certificación práctica y entrenamiento multimarca.`,
                        category: "common"
                    },
                    {
                        q: "¿Cuáles son los problemas comunes relacionados a baja eficiencia en la gestión de efectivo?",
                        a: `- Cajeros que no reciclan billetes eficientemente.
- Errores en conciliación de efectivo.
- Costos elevados en logística de valores.

Solución ATMNet: optimización de módulos recicladores, asesoría en gestión de efectivo, integración de soluciones de autoservicio.`,
                        category: "common"
                    },
                    {
                        q: "¿Cuántos cajeros mantiene actualmente ATM Net?",
                        a: `Mantenemos más de 3.000 cajeros automáticos en la región, trabajando con bancos, redes de cajeros y empresas de transporte de valores.`,
                        category: "common"
                    },
                    {
                        q: "¿Cuántos años de experiencia tienen con NCR y Diebold Nixdorf?",
                        a: `Contamos con más de 23 años de experiencia trabajando con NCR y Diebold Nixdorf, además de otros fabricantes líderes del mercado.`,
                        category: "common"
                    },
                    {
                        q: "¿Qué fallas técnicas solucionan para cajeros automáticos?",
                        a: `Reparamos dispensadores, recicladores, lectores de tarjetas y EPPs, entre otros.
Nuestros técnicos diagnostican, reemplazan módulos y verifican funcionalidad completa del equipo antes de su entrega.`,
                        category: "common"
                    },
                    {
                        q: "¿Qué problemas causa la alta indisponibilidad de cajeros?",
                        a: `La falta de mantenimiento genera:
- Equipos fuera de servicio por horas o días.
- Pérdida de transacciones y clientes insatisfechos.
- Riesgo reputacional y sobrecarga operativa.

Solución: mantenimiento preventivo, contratos SLA y modelo VOI para disponibilidad inmediata de repuestos.`,
                        category: "common"
                    },
                    {
                        q: "¿Por qué se elevan los costos de mantenimiento y repuestos?",
                        a: `- Dependencia de fabricantes y tiempos de importación.
- Fallas recurrentes y gastos imprevistos.

Solución: inventarios locales, repuestos reacondicionados con garantía y precios competitivos.`,
                        category: "common"
                    },
                    {
                        q: "¿Qué problemas de seguridad puede presentar un cajero?",
                        a: `- Teclados EPP comprometidos.
- Módulos manipulados.
- Falta de actualización segura.

Solución: provisión de EPPs certificados, protocolos de seguridad y capacitación técnica.`,
                        category: "common"
                    },
                    {
                        q: "¿Qué impacto tiene la falta de personal técnico especializado?",
                        a: `Alta rotación y pérdida de conocimiento operativo.

Solución: formación continua a través de ATM Net School, con certificación práctica y entrenamiento multimarca.`,
                        category: "common"
                    },
                    {
                        q: "¿Cuáles son los problemas más comunes en la gestión de efectivo?",
                        a: `- Cajeros que no reciclan billetes de forma eficiente.
- Errores en conciliación.
- Costos altos en logística de valores.

Solución: optimización de recicladores y asesoría en gestión de efectivo.`,
                        category: "common"
                    },

                    // ---------- Categoría: Repuestos ----------
                    {
                        q: "¿Las partes que venden son originales o reacondicionadas?",
                        a: `Ofrecemos repuestos originales, genéricos y reacondicionados, nuevos o usados, según las necesidades del cliente y la disponibilidad de marca.
Todos nuestros repuestos pasan por un proceso de verificación técnica y control de calidad que garantiza su desempeño en campo.`,
                        category: "spare"
                    },
                    {
                        q: "¿Qué garantía tienen los repuestos?",
                        a: `Los repuestos nuevos cuentan con la garantía del fabricante.
Los reacondicionados tienen una cobertura de hasta 30 días, respaldada por nuestros laboratorios certificados.`,
                        category: "spare"
                    },
                    {
                        q: "¿Cómo garantizan la seguridad de los equipos durante la reparación?",
                        a: `Todos los equipos se reparan en laboratorios seguros y auditados, con protocolos de trazabilidad, control de acceso y registro fotográfico.`,
                        category: "spare"
                    },

                    // ---------- Categoría: SLA ----------
                    {
                        q: "¿Pueden despachar repuestos de urgencia en menos de 24 horas?",
                        a: `Sí. Cuando hay disponibilidad de inventario, podemos enviar repuestos críticos en menos de 24 horas, gracias a nuestras sedes logísticas en Bogotá, Guayaquil y Ciudad de Guatemala.`,
                        category: "sla"
                    },
                    {
                        q: "¿Qué incluye un contrato de mantenimiento preventivo y correctivo?",
                        a: `Nuestros contratos combinan:
- Mantenimiento preventivo, para evitar fallas y extender la vida útil del equipo.
- Mantenimiento correctivo, para resolver averías y restaurar la operación rápidamente.
- Condiciones de servicio (SLA), que incluyen cobertura, tiempos de respuesta y reportes periódicos.`,
                        category: "sla"
                    },
                    {
                        q: "¿Atienden fallas en sitio o solo en laboratorio?",
                        a: `Ofrecemos ambas modalidades. Nuestro equipo técnico atiende reparaciones en campo o en laboratorio, según la naturaleza del daño y el tipo de módulo afectado.`,
                        category: "sla"
                    },
                    {
                        q: "¿En cuánto tiempo se repara un módulo?",
                        a: `Depende del tipo de módulo y la disponibilidad de partes, pero el tiempo promedio de reparación oscila entre 1 y 4 horas.`,
                        category: "sla"
                    },
                    {
                        q: "¿Tienen cobertura nacional?",
                        a: `Sí. Prestamos servicio en principales ciudades y zonas aledañas. También contamos con alianzas locales para cubrir regiones adicionales.`,
                        category: "sla"
                    },
                    {
                        q: "¿Ofrecen servicio 24/7?",
                        a: `Operamos bajo acuerdos SLA personalizados, que pueden incluir atención 24/7 dependiendo del tipo de contrato y la criticidad de la operación.`,
                        category: "sla"
                    },
                    {
                        q: "¿Qué es el modelo VOI (Vendor Owned Inventory)?",
                        a: `Es un modelo en el que ATM Net mantiene la propiedad del inventario, entregado al cliente en comodato por una tarifa mensual por cajero.
La tarifa cubre la reparación de módulos incluidos en el contrato, optimizando costos, tiempos de respuesta y disponibilidad.`,
                        category: "sla"
                    },
                    {
                        q: "¿Ofrecen descuentos por volumen o contratos anuales?",
                        a: `Sí. A mayor cantidad de cajeros y duración del contrato, mejor tarifa. Ajustamos el precio según volumen y cobertura.`,
                        category: "sla"
                    },
                    {
                        q: "¿Puedo contratar solo repuestos o también el servicio completo?",
                        a: `Ambos. Puedes adquirir solo las partes, o un servicio integral que incluya mantenimiento, soporte y reposición de módulos.`,
                        category: "sla"
                    },
                    {
                        q: "¿Ofrecen precios FOB o entregas directas en Latinoamérica?",
                        a: `Sí. Ofrecemos precios FOB/EXW desde EE. UU. o Colombia, y entregas directas en Colombia, Ecuador y Guatemala, según preferencia del cliente.`,
                        category: "sla"
                    },
                    {
                        q: "¿Qué ocurre si no tienen en stock la parte que necesito?",
                        a: `Verificamos disponibilidad en nuestras tres sedes regionales (Bogotá, Guayaquil y Guatemala).
Si no está disponible, se importa directamente desde fábrica, y el modelo VOI minimiza la probabilidad de falta de inventario.`,
                        category: "sla"
                    },

                    // ---------- Categoría: School ----------
                    {
                        q: "¿Pueden capacitar a mi equipo técnico?",
                        a: `Sí. En ATM Net School capacitamos a técnicos internos o externos con programas prácticos en diagnóstico, reparación y mantenimiento multimarca.`,
                        category: "school"
                    },
                    {
                        q: "¿Los cursos son presenciales o virtuales?",
                        a: `La mayoría de los cursos son presenciales, por la naturaleza práctica del entrenamiento.
Sin embargo, ofrecemos modalidades híbridas y entrenamientos en las instalaciones del cliente si se requiere.`,
                        category: "school"
                    },
                    {
                        q: "¿Entregan certificaciones?",
                        a: `Sí. Todos nuestros programas entregan certificados oficiales de ATM Net School, reconocidos en la industria.`,
                        category: "school"
                    },
                    {
                        q: "¿En qué marcas de cajeros entrenan?",
                        a: `Entrenamos sobre los principales fabricantes: NCR, Diebold Nixdorf, Hyosung y Cashway, en todas sus familias y generaciones.`,
                        category: "school"
                    },
                    {
                        q: "¿Cuánto dura el entrenamiento?",
                        a: `Cada módulo de entrenamiento tiene una duración promedio de 40 horas.
Los precios varían según la complejidad del curso, entre USD 15.000 y USD 25.000.`,
                        category: "school"
                    }
                ]
            },



            titleHome: "Transformando el autoservicio con innovadora tecnología",
            description: "Esta es una aplicación de ejemplo con soporte multilingüe.",
            email_atm: "info@atmnetss.com",
            address_atm: "1555 Oakbrook Drive, Suite 105",
            zipcode_atm: "Norcross, Georgia 30093",
            general_information: "Información General",
            address: "Dirección",
            phone: "Teléfono",
            home_title_school: "ATMSchool",
            home_contact_text: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper",
            home_contact_text1: "Para cualquier consulta o solicitud de soporte, complete el formulario a continuación.",
            home_contact_text2: "Si prefiere hablar con nosotros directamente, llámenos.",
            school_titel1: "Impulsando la educación en técnica y tecnología a través de la experiencia en AtmSchool Net",
            school_text1: "En Atm Net Systems and Solutions, entendemos la importancia de la educación en el campo de la tecnología financiera. Estamos comprometidos a contribuir a este campo integrando técnica, tecnología, conocimiento y desarrollo de productos para crear cajeros automáticos seguros y avanzados. Nuestras unidades interactivas para el control y seguridad del dinero, junto con nuestros sistemas de reportes en línea, brindan una solución integral para las instituciones financieras. Únase a nosotros para dar forma al futuro de la tecnología financiera.",
            us: "Nosotros",
            contact: "Contacto",
            banks: "Bancos",
            atms: "Cajeros Automáticos",
            services: "Servicios",
            retail: "Retail",
            footer: {
                cookies_settings: "Configuración de cookies",
                terms_of_service: "Términos de servicio",
                privacy_policy: "Política de privacidad",
                rights_reserved: "© 2025 Relume. Todos los derechos reservados"
            },
            school: {
                text_prueba: "Manténgase actualizado con nuestros últimos lanzamientos de productos",
                title: "ATM net School",
                text1: "En nuestras sesiones de laboratorio transformamos procesos para la optimización de los recursos y mejoramiento del servicio. Búsqueda de soluciones a errores con procesos eficiente, gracias a nuestra larga experiencia en campo y reconstrucción de equipos.",
                text2: "En Atm Net Systems and Solutions, entendemos la importancia de la educación en el campo de la tecnología financiera. Estamos comprometidos a contribuir a este campo integrando técnica, tecnología, conocimiento y desarrollo de productos para crear cajeros automáticos seguros y avanzados. Nuestras unidades interactivas para el control y seguridad del dinero, junto con nuestros sistemas de reportes en línea, brindan una solución integral para las instituciones financieras. Únase a nosotros para dar forma al futuro de la tecnología financiera.",
                text3: "Únase a nosotros para dar forma al futuro de la tecnología financiera.",
                text4: "Contáctenos para más información",
                subtitle: "Impulsando la educación técnica y tecnológica",
                subtitle2: "para adquirir un pensamiento analítico en la optimización de diagnóstico y búsqueda de soluciones eficientes.",
                subtitle3: "Formando técnicos transformamos sus procesos de servicio.",
                subtitle4: "Está interesado en capacitar a sus equipos",
                title1: "Potenciar la educación a través de cajeros automáticos y tecnología financiera",
                parrafo1: "En nuestras sesiones de laboratorio transformamos procesos para la optimización de los recursos y mejoramiento del servicio. Búsqueda de soluciones a errores con procesos eficiente, gracias a nuestra larga experiencia en campo y reconstrucción de equipos.",
                title2: "Lista de cursos, seminarios y talleres disponibles",
                title3: "Está interesado en capacitar a sus equipos",
                parrafo3: "Contáctenos para más información",
                numero: "Número*",
                nombre: "Nombres(s)*",
                apellido: "Apellido(s)*",
                email: "Email*",
                select_field: "Elige un tema",
                submit: "Enviar",
                category: "categoría",
                titleImg1: "Servicio",
                titleImg2: "Laboratorio",
                titleImg3: "Monitoreo",
                titleImg4: "Análisis de faltantes y reconciliación de cajeros automáticos",
                titleImg5: "Capacitación para técnicos de primera línea, y abastecedores de cajero automático",
                titleImg6: "Entrenamiento en protocolos de aplicación para cajeros automáticos (NDC, Debold 912)",
                textImg1: "Entrenamiento en mantenimiento preventivo y correctivo de cajeros automáticos.",
                textImg2: "Entrenamiento para desarrollo de sistema de laboratorio para mejorar los proceso en búsqueda de actividades más eficientes.",
                textImg3: "Introducción a cajeros automáticas y mejores prácticas de monitoreo, para operadores de gestión de red en sala.",

            },
            atm: {
                title: "Descubra las soluciones para cajeros automáticos",
                parrafo1: "Controle los costos, la complejidad y el riesgo con nuestra solución integral decajeros automáticos, un servicio que maneja todo lo necesario para ejecutar elcanal de cajeros automáticos, para que pueda concentrarse en hacer crecersu institución financiera y brindar experiencias excepcionales a los clientes."
            },
            contacto: {
                title: "¡contáctenos!",
                text1: "¿Tiene alguna pregunta o necesita ayuda? Póngase en contacto con nosotros.",
                email: "Correo electrónico",
                textEmail: "Para cualquier consulta o solicitud de soporte, contáctenos. asaavedra@atmnetss.com",
                phone: "Teléfono",
                textPhone: "Si prefiere hablar con nosotros directamente, llámenos. +1 770 449 6545",
                subtitle2: "Nuestras sedes",
                text2: "Encuentre nuestras oficinas centrales y centros de servicio cerca de usted.",
                titleImg1: "Sede: Atlanta, EE.UU.",
                textImg1: "América del norte",
                titleImg2: "Bogotá Colombia, Guayaquil Ecuador",
                textImg2: "Latinoamérica",
                titleImg3: "Ciudad de Guatemala, Guatemala",
                textImg3: "Centroamérica",
            },
            servicios: {
                title: "Servicios",
                subtitle1: "Asesorías",
                text1: "En Atm Net Systems and Solutions, ofrecemos una amplia gama de servicios que integran tecnología, conocimiento y desarrollo de productos para proporcionar cajeros automáticos seguros y avanzados. Nuestra experiencia en el campo del autoservicio ha transformado los modelos de negocio convencionales y trabajamos con todas las marcas de cajeros automáticos más reconocidas del mercado. Con nuestras unidades interactivas para control y seguridad del dinero, sistemas de informes en línea y desarrollo e implementación de sistemas de seguridad transnacionales, estamos comprometidos a brindar soluciones innovadoras para satisfacer sus necesidades de servicios financieros.",
                textImg1: "Asesoría a compañías que deseen montar redes de cajeros de bajo costo o redes de cajeros automáticos bancarias. ",
                textImg2: "Compañías que ofrecen actualmente cajeros automáticos que quieren mejorar sus servicios.",
                textImg3: "Compañías de transportadoras  de valores que están desarrollando sus programas  de segunda línea de cajeros automáticos.",
                services: "Servicios",
                subtitle2: "Sistemas de seguridad transnacionales",
                text2: "En Atm Net Systems and Solutions, nos especializamos en el desarrollo e implementación de sistemas avanzados de seguridad transnacional para la industria logística. Nuestra experiencia en tecnología y conocimiento nos permite brindar soluciones innovadoras que garantizan la seguridad y protección de activos valiosos durante el transporte y almacenamiento.",
                subtitle3: "Soluciones de logística segura",
                text3: "Nuestras soluciones de logística segura están diseñadas para satisfacer las necesidades únicas de las empresas que operan en un mundo globalizado. Ofrecemos servicios integrales que abarcan toda la cadena de suministro, desde el transporte seguro hasta el almacenamiento y la distribución seguros. Con nuestros sistemas avanzados y nuestra experiencia, puede confiar en nosotros para salvaguardar sus valiosos activos durante todo el proceso logístico.",
                subtitle4: "Servicios de mitigación de riesgos",
                text4: "Atm Net Systems and Solutions brinda servicios de mitigación de riesgos para ayudar a las empresas a minimizar las posibles amenazas y vulnerabilidades en sus operaciones logísticas. Nuestro equipo de expertos evaluará sus medidas de seguridad actuales y desarrollará estrategias personalizadas para mitigar los riesgos y mejorar la seguridad de sus activos. Con nuestras soluciones integrales, podrá tener la tranquilidad de saber que sus operaciones logísticas están protegidas.",
                transforming: "Transformando modelos de negocio a través de la innovación",
                textTransform: "Contáctenos hoy para obtener más información o programar una consulta.",
                contactus: "Contáctenos",
                solutions: "Soluciones",
                item1: "Integración de procesos y creación de redes de cajeros automáticos para sistemas bancarios.",
                item2: "VOI (Vendor Owned Inventory in Customer’s Network) desarrollo de estrategias de servicio.",
                item3: "Implementación de sistemas POS , Banca y Retail.",
                item4: "Cajeros automáticos Nuevos y Reconstruidos.",
                item5: "Partes y Consumibles.",
                item6: "Consultoría.",
                item7: "Entrenamiento.",
                item8: "Construcción de sites para cajeros automáticos e instalación de equipos a nivel nacional.",
                item9: "Mantenimiento FLM y SLM a nivel nacional.",
                item10: "Servicios logísticos especializados en equipo Bancario.",
                item11: "Seguridad (filmación transaccional, sistemas de control de acceso, otros).",
                item12: "Análisis Forense.",
            },
            seo: {
                home: {
                    title: "ATM Net Systems — Tecnología de autoservicio y ATMs",
                    description:
                        "Diseñamos, implementamos y mantenemos soluciones de autoservicio y cajeros para banca y retail. Consultoría, logística, capacitación y mantenimiento a nivel regional.",
                    pathByLang: { es: "/", en: "/" },
                    keywords:
                        "seguridad cajeros automáticos, suministros para cajeros automáticos, reparación de dispensadores de billetes, certificado cajeros, consultoría ATM"
                },
                about: {
                    title: "Nosotros — 22+ años impulsando el autoservicio",
                    description:
                        "Presencia global con sedes en EE. UU. y LATAM. Más de 22 años mejorando la operación financiera con hardware, software y servicios expertos de autoservicio.",
                    pathByLang: { es: "/nosotros", en: "/en/about-us" },
                    keywords:
                        "contratos de mantenimiento ATM, curso mantenimiento cajeros, curso entrenamiento cajeros, capacitación técnicos cajeros Ecuador, certificación técnicos cajeros NCR Diebold LATAM"
                },
                banks: {
                    title: "Soluciones para bancos — ATMs, logística y seguridad",
                    description:
                        "Programas integrales de ATM: equipos nuevos/remanufacturados, mantenimiento FLM/SLM, construcción e instalación de sites, logística, partes, consultoría y formación.",
                    pathByLang: { es: "/bancos", en: "/en/banks" },
                    keywords:
                        "repuestos cajeros automáticos NCR Colombia, repuestos cajeros automáticos Diebold Ecuador, venta de repuestos cajeros automáticos Guatemala, partes ATM originales NCR Bogotá, partes ATM compatibles Medellín"
                },
                retail: {
                    title: "Retail — Control de efectivo e integración POS",
                    description:
                        "Tecnología propietaria para retail: unidades interactivas de control de efectivo, reportes en línea y plataformas de seguridad transaccional para mayor eficiencia.",
                    pathByLang: { es: "/retail", en: "/en/retail" },
                    keywords:
                        "mantenimiento cajeros automáticos Colombia, mantenimiento preventivo cajeros Ecuador, reparación cajeros automáticos NCR Bogotá, reparación cajeros automáticos Diebold Medellín, servicio técnico ATM Guatemala"
                },
                atms: {
                    title: "Cajeros automáticos — Nuevos, reacondicionados y rebuild",
                    description:
                        "Maximiza costos y disponibilidad con servicios 360°: venta y alquiler, reconstrucción, mantenimiento a nivel nacional, instalación y gestión de inventario.",
                    pathByLang: { es: "/cajerosautomaticos", en: "/en/atms" },
                    keywords:
                        "soporte técnico cajeros automáticos Ecuador, contratos de mantenimiento cajeros Colombia, outsourcing mantenimiento cajeros Guatemala, cursos de reparación cajeros automáticos Colombia, venta de cajeros automáticos Ecuador"
                },
                school: {
                    title: "ATMnet School — Capacitación técnica y de operaciones",
                    description:
                        "Cursos y talleres prácticos: mantenimiento preventivo/correctivo, protocolos, mejores prácticas de monitoreo y métodos de laboratorio para elevar la calidad del servicio.",
                    pathByLang: { es: "/school", en: "/en/school" },
                    keywords:
                        "capacitación técnicos cajeros Ecuador, certificación técnicos cajeros NCR Diebold LATAM, curso entrenamiento cajeros, curso mantenimiento cajeros"
                },
                services: {
                    title: "Servicios — Consultoría, integración y mantenimiento",
                    description:
                        "Servicios especializados para banca y retail: estrategias VOI, integración de redes de ATM, sistemas POS/Banca, logística segura y mitigación de riesgos.",
                    pathByLang: { es: "/servicios", en: "/en/services" },
                    keywords:
                        "consultoría ATM, cámaras seguridad ATM Bogotá, seguridad en cajeros automáticos Colombia, reparación de cajeros automáticos, contratos de mantenimiento ATM"
                },
                contact: {
                    title: "Contáctenos — Oficinas en EE. UU. y Latinoamérica",
                    description:
                        "Escríbanos para ventas, soporte o capacitación. Sede en Atlanta y presencia regional en Colombia, Ecuador y Guatemala.",
                    pathByLang: { es: "/contactenos", en: "/en/contact" },
                    keywords:
                        "ATMNet Colombia, ATMNet Ecuador, ATMNet Guatemala, oficinas cajeros automáticos LATAM, soporte cajeros automáticos contacto"
                }
            }

        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en", // Idioma por defecto
        fallbackLng: "en",
        interpolation: {
            escapeValue: false // React ya hace escaping por defecto
        }
    });

export default i18n;